import { useState } from "react";
import { canAnalyzeHearingResult } from "./hearingResultAnalysis";
import { useToast } from "../components/toast/toast";
import { useI18n } from "./translate/i18n/useI18n";
import type { HearingTestResultPayload } from "../type/result";
import { logActivity } from "./logActivity";

export function useAnalysisModal(result: HearingTestResultPayload | null, idtonalresult?: number | null) {
  const { t } = useI18n();
  const { showToast } = useToast();
  const [isAnalysisModalOpen, setIsAnalysisModalOpen] = useState(false);

  const handleCloseAnalysisModal = () => {
    setIsAnalysisModalOpen(false);
  };

  const handleAnalyzeResults = () => {
    if (!result) {
      return;
    }

    if (!canAnalyzeHearingResult(result)) {
      showToast(t("Analiza wyników jest dostępna dopiero wtedy, gdy co najmniej jedna wartość przekracza 5 dB."), "warning");
      return;
    }

    logActivity("analyze_results", window.location.pathname, "Otwarto analizę wyników", idtonalresult ?? null);
    setIsAnalysisModalOpen(true);
  };

  return {
    isAnalysisModalOpen,
    handleCloseAnalysisModal,
    handleAnalyzeResults
  };
}
